module.exports = __webpack_public_path__ + "img/quanxian.5bfca565.png";